export const getBlobUrl = (attachment = '', fileExtension) => {
  if (attachment) {
    const data = Buffer.from(attachment, 'base64');
    const url =
      fileExtension === 'pdf'
        ? window.URL.createObjectURL(
            new Blob([data], {
              type: 'application/pdf',
            })
          )
        : window.URL.createObjectURL(new Blob([data]));

    return url;
  } else {
    return null;
  }
};
